export class GCPortalkarteStyle {
    /**
     * Durchsichtigkeit
     * @private
     */
    private opacity = 0.6;

    /**
     * Füllfarbe
     * @private
     */
    private fill_color = '#f57878';

    /**
     * Linienfarbe
     * @private
     */
    private stroke_color = '#ff0000';

    /**
     * Linienstärke
     * @private
     */
    private stroke_width=  3;

    /**
     *
     * @private
     */
    private radius = 1;

    /**
     * Konstruktor
     */
    public constructor() {
        this.radius = this.stroke_width+5;
    }

    /**
     *
     */
    public getOpacity(): number
    {
        return this.opacity;
    }

    /**
     *
     * @param {number} value
     */
    public setOpacity(value:number): GCPortalkarteStyle
    {
        this.opacity = value;
        return this;
    }

    /**
     *
     */
    public getFillColor(): string
    {
        return this.fill_color;
    }

    /**
     *
     * @param {string} value
     */
    public setFillColor(value:string): GCPortalkarteStyle
    {
        this.fill_color = value;
        return this;
    }

    /**
     *
     */
    public getStrokeColor(): string
    {
        return this.stroke_color;
    }

    /**
     *
     * @param {string} value
     */
    public setStrokeColor(value:string): GCPortalkarteStyle
    {
        this.stroke_color = value;
        return this;
    }

    /**
     *
     */
    public getStrokeWidth(): number
    {
        return this.stroke_width;
    }

    /**
     *
     * @param {string} value
     */
    public setStrokeWidth(value:number): GCPortalkarteStyle
    {
        this.stroke_width = value;
        return this;
    }

    /**
     *
     */
    public getRadius(): number
    {
        return this.radius;
    }

    /**
     *
     * @param {string} value
     */
    public setRadius(value:number): GCPortalkarteStyle
    {
        this.radius = value;
        return this;
    }

    /**
     *
     * @param ol
     */
    public create(ol:any)
    {
        if (ol && ol.style) {
            return new ol.style.Style({
                fill: new ol.style.Fill({
                    color: this.fill_color,
                }),
                stroke: new ol.style.Stroke({
                    color: this.stroke_color,
                    width: this.stroke_width,
                }),
                image: new ol.style.Circle({
                    radius: this.radius,
                    fill: new ol.style.Fill({
                        color: this.stroke_color,
                    }),
                }),
            });
        }

        return null;
    }

}